import HBIcon from "@/components/HBIcon";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { STATUS, UploadResource } from "../shared";
import styles from "./index.module.less";

const ShortErrMap: Record<string, string> = {
  "该图片你已经采集超过5次，无法完成采集，换一张试试吧": "采集多次",
  "花瓣系统检测到该图片内容可能违规，不能采集到你的画板，换一张试试吧。":
    "图片违规",
};

export default function ImageAvatar({
  resource,
  selected,
  onSelect,
  onRemove,
  onReUpload,
}: {
  resource: UploadResource;
  selected?: boolean;
  onSelect?: (r: UploadResource) => void;
  onRemove?: (r: UploadResource) => void;
  onReUpload?: (r: UploadResource) => void;
}) {
  const status = resource.status;

  return (
    <div
      className={classNames(styles.imageAvatar, {
        [styles.selected]: selected,
      })}
      onClick={() => onSelect?.(resource)}
    >
      <div className={styles.imgWrapper}>
        {resource.url ? (
          <img
            className="transparent-img-bg"
            src={
              resource.ossFile
                ? imageUrl(resource.ossFile, { width: 240 })
                : resource.url
            }
            width={84}
            height={84}
            alt="图片"
          />
        ) : (
          <div style={{ width: 58, height: 58, background: "#edf2f5" }} />
        )}

        <div
          className={styles.closeBtn}
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.(resource);
          }}
        >
          <HBIcon type="ic_close" />
        </div>

        <div
          className={classNames(styles.cover, {
            [styles.show]: status !== STATUS.DONE,
          })}
        >
          {status === STATUS.UPLOADING && (
            <div className={styles.progressContainer}>
              <div
                className={styles.progress}
                style={{ width: `${resource.progress}%` }}
              />
            </div>
          )}
          {status === STATUS.FAILURE && (
            <div className={styles.errorTip}>
              <HBIcon className={styles.icon} type="ic_alert" />
              {resource.failMsg && (
                <div className={styles.failMsg}>
                  {ShortErrMap[resource.failMsg] || "上传失败"}
                </div>
              )}
              <div className={styles.errorActions}>
                {!resource.failMsg && (
                  <div
                    className={styles.reuploadBtn}
                    onClick={() => onReUpload?.(resource)}
                  >
                    重新上传
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
